/**
 *
 */
export enum EngineerViewType {
    Edit = "engineerEdit",
    View = "engineerView", // Note also present in FilterType
}